import React from "react"
import CircularProgress from '@mui/material/CircularProgress';


interface IProps {
    height: number
}

const Loader: React.FC<IProps> = ({height}) => {


    return (
        <div className={'base_loader'} style={{height: `${height}px`}}>
            <CircularProgress/>
        </div>
    )
}

export default Loader